import ApiUrl from 'enum/api-url.enum';
import httpService from 'services/http/http.service';

function getGrpWallpapers(params) {
  let url = ApiUrl?.GRPWALLPAPER;
  if (params) {
    const queryParams = Object.keys(params)
      .map(key => `${key}=${encodeURIComponent(params[key])}`)
      .join('&');
    url += `?${queryParams}`;
  }
  return httpService.get(url);
}

const obj = { getGrpWallpapers };

export default obj;
